import { useEffect } from 'react';

const DRAG_IN_PROGRESS_BODY_CLASS = 'drag-in-progress';

// Mid-drag the pointer sits over sibling elements rather than the one that
// started the drag, so the closed-hand cursor has to be forced document-wide.
export function useGrabbingCursor(isDragging: boolean): void {
    useEffect(() => {
        if (!isDragging) {
            return;
        }
        document.body.classList.add(DRAG_IN_PROGRESS_BODY_CLASS);
        return () =>
            document.body.classList.remove(DRAG_IN_PROGRESS_BODY_CLASS);
    }, [isDragging]);
}
